import { Modal } from 'rsuite';
import { ButtonPrimary } from '../../../../../../components';
import styles from '../SetupIpaPricingResponsibilities.module.scss';
import { PricerAssignment } from '../types';

type RemoveAssignmentModalProps = {
  assignment: PricerAssignment | null;
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export const RemoveAssignmentModal = ({ assignment, loading, onCancel, onConfirm }: RemoveAssignmentModalProps) => (
  <Modal className={styles['confirmation-modal']} show={assignment != null} onHide={onCancel} size="xs">
    <Modal.Header>
      <Modal.Title>Remover atribuição</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>
        Tem certeza que quer remover a atribuição de <strong>{assignment?.userName}</strong>? Ele deixará de ser responsável por{' '}
        <strong>
          {assignment?.categories.length ?? 0} {(assignment?.categories.length ?? 0) === 1 ? 'categoria' : 'categorias'}
        </strong>
        .
      </p>
      <small>O usuário continua cadastrado no IPA, apenas a atribuição é removida.</small>
    </Modal.Body>
    <Modal.Footer>
      <ButtonPrimary size="medium" theme="ghost" type="button" onClick={onCancel}>
        cancelar
      </ButtonPrimary>
      <ButtonPrimary size="medium" skin="red" isLoading={loading} type="button" onClick={onConfirm}>
        remover
      </ButtonPrimary>
    </Modal.Footer>
  </Modal>
);
